import React, {
  useEffect,
  useState
} from "react";

import YouTube from "react-youtube";

import BaseURL from "../../assets/utils/baseUrl";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";

import {
  Breadcrumb,
  Footer,
  Header,
  Sidebar
} from "../../components";

import "./style.scss";

function BeritaVideo() {

  useDocumentTitle(
    "Berita Video - BAPENDA BEKASI"
  );

  // =========================
  // STATE
  // =========================

  const [video, setVideo] =
    useState([]);

  const [videoPlay, setVideoPlay] =
    useState(null);

  const [videoPerPage,
    setVideoPerPage] =
    useState([]);

  const [currentPage,
    setCurrentPage] =
    useState(1);

  const [loading,
    setLoading] =
    useState(true);

  // =========================
  // FETCH API
  // =========================

  useEffect(() => {

    const controller =
      new AbortController();

    const getVideo =
      async () => {

        try {

          setLoading(true);

          const response =
            await fetch(

              BaseURL +
              "index.php/api/Berita_video?jumlah_item=9",

              {
                method: "GET",

                headers: {
                  Accept:
                    "application/json",

                  "Content-Type":
                    "application/json",

                  "X-API-KEY":
                    process.env
                      .REACT_APP_API_KEY
                },

                signal:
                  controller.signal
              }
            );

          // =========================
          // VALIDASI RESPONSE
          // =========================

          if (!response.ok) {

            throw new Error(
              "HTTP Error " +
              response.status
            );
          }

          const result =
            await response.json();

          console.log(
            "VIDEO API:",
            result
          );

          // =========================
          // VALIDASI DATA
          // =========================

          if (
            result &&
            result.status === true &&
            Array.isArray(
              result.data
            ) &&
            result.data.length > 0
          ) {

            // =========================
            // GROUP PER 3 VIDEO
            // =========================

            const groupedVideo =
              [];

            for (
              let i = 0;
              i < result.data.length;
              i += 3
            ) {

              groupedVideo.push(

                result.data.slice(
                  i,
                  i + 3
                )
              );
            }

            setVideo(
              groupedVideo
            );

            setVideoPerPage(
              groupedVideo[0]
            );

            setVideoPlay(
              groupedVideo[0][0]
            );

          } else {

            setVideo([]);
            setVideoPerPage([]);
            setVideoPlay(null);
          }

        } catch (error) {

          if (
            error.name !==
            "AbortError"
          ) {

            console.error(
              "ERROR VIDEO:",
              error
            );
          }

          setVideo([]);
          setVideoPerPage([]);
          setVideoPlay(null);

        } finally {

          setLoading(false);
        }
      };

    getVideo();

    return () =>
      controller.abort();

  }, []);

  // =========================
  // NEXT PAGE
  // =========================

  const nextPage = () => {

    if (
      currentPage <
      video.length
    ) {

      const next =
        currentPage + 1;

      setCurrentPage(next);

      setVideoPerPage(
        video[next - 1]
      );

      setVideoPlay(
        video[next - 1][0]
      );
    }
  };

  // =========================
  // PREV PAGE
  // =========================

  const prevPage = () => {

    if (currentPage > 1) {

      const prev =
        currentPage - 1;

      setCurrentPage(prev);

      setVideoPerPage(
        video[prev - 1]
      );

      setVideoPlay(
        video[prev - 1][0]
      );
    }
  };

  // =========================
  // YOUTUBE OPTION
  // =========================

  const opts = {
    width: "100%",
    playerVars: {
      autoplay: 0
    }
  };

  // =========================
  // RENDER
  // =========================

  return (

    <div className="page">

      <Header active="publikasi" />

      <main className="main-sb">

        <section className="content">

          <Breadcrumb
            path="Publikasi / Berita Video"
          />

          <div className="page-title-wrapper">

            <div className="page-title">
              Berita Video
            </div>

          </div>

          {/* ========================= */}
          {/* LOADING */}
          {/* ========================= */}

          {
            loading ? (

              <div
                style={{
                  textAlign: "center",
                  padding: 20
                }}
              >
                Loading...
              </div>

            ) : (
              <>
                {/* ========================= */}
                {/* PLAYER */}
                {/* ========================= */}

                {
                  videoPlay ? (

                    <div className="section-youtube-play">

                      <YouTube
                        videoId={
                          videoPlay.id_video
                        }
                        opts={opts}
                        className="youtube-iframe-bv"
                      />

                    </div>

                  ) : (

                    <div
                      style={{
                        textAlign: "center",
                        padding: 20
                      }}
                    >
                      Belum ada berita video
                    </div>
                  )
                }

                {/* ========================= */}
                {/* GRID VIDEO */}
                {/* ========================= */}

                <div className="section-youtube-grid">

                  {
                    Array.isArray(
                      videoPerPage
                    ) &&

                    videoPerPage.map(
                      (
                        item,
                        index
                      ) => (

                        <div
                          key={
                            item.id_berita_video ||
                            index
                          }

                          style={{
                            display: "flex",
                            flexDirection:
                              "column"
                          }}
                        >

                          <div
                            className="youtube-item"

                            onClick={() =>
                              setVideoPlay(
                                item
                              )
                            }
                          >

                            <img
                              src={
                                item.thumbnail ||
                                "/no-image.png"
                              }

                              alt={
                                item.judul ||
                                "video"
                              }

                              loading="lazy"

                              style={{
                                width: "100%",
                                objectFit:
                                  "cover"
                              }}

                              onError={(e) => {

                                e.target.src =
                                  "/no-image.png";
                              }}
                            />

                            <div className="youtube-icon-wrapper">

                              <i className="fab fa-youtube youtube-icon"></i>

                            </div>

                          </div>

                          <div className="youtube-title">

                            {
                              item.judul ||
                              "-"
                            }

                          </div>

                        </div>
                      )
                    )
                  }

                </div>

                {/* ========================= */}
                {/* PAGINATION */}
                {/* ========================= */}

                {
                  video.length > 1 && (

                    <div className="berita-video-pagination-wrapper">

                      {
                        currentPage > 1 && (

                          <div
                            className="next-page-button"

                            onClick={
                              prevPage
                            }
                          >
                            Sebelumnya...
                          </div>
                        )
                      }

                      <div
                        style={{
                          width: 10
                        }}
                      />

                      {
                        currentPage <
                        video.length && (

                          <div
                            className="next-page-button"

                            onClick={
                              nextPage
                            }
                          >
                            Selanjutnya...
                          </div>
                        )
                      }

                    </div>
                  )
                }
              </>
            )
          }

        </section>

        <Sidebar />

      </main>

      <Footer />

    </div>
  );
}

export default BeritaVideo;